// Per-model pricing for cost telemetry. Rates in USD per MILLION tokens.
// Source: anthropic.com/pricing (as of 2026-04). Update when rates change.
// Reference, not contractual — your invoice is what it is.

export const MODEL_PRICES = {
  'claude-sonnet-4-20250514':   { inputPerMTok: 3.0,  outputPerMTok: 15.0 },
  'claude-haiku-4-5-20251001':  { inputPerMTok: 1.0,  outputPerMTok: 5.0 },
  // Sensible default for any model not in the table — Sonnet rates so we
  // over-estimate rather than under-estimate.
  _default:                     { inputPerMTok: 3.0,  outputPerMTok: 15.0 },
};

/**
 * Returns USD cost for a single Anthropic call.
 * @param {string} model
 * @param {number} inputTokens
 * @param {number} outputTokens
 * @returns {number}
 */
export function costFor(model, inputTokens = 0, outputTokens = 0) {
  const rates = MODEL_PRICES[model] || MODEL_PRICES._default;
  return (
    (Number(inputTokens) || 0) / 1_000_000 * rates.inputPerMTok +
    (Number(outputTokens) || 0) / 1_000_000 * rates.outputPerMTok
  );
}

/**
 * Sum a collection of per-step usage rows.
 * @param {Array<{ model: string, inputTokens: number, outputTokens: number }>} rows
 * @returns {{ inputTokens: number, outputTokens: number, totalTokens: number, costUsd: number }}
 */
export function aggregateUsage(rows) {
  const out = { inputTokens: 0, outputTokens: 0, totalTokens: 0, costUsd: 0 };
  for (const r of rows || []) {
    const i = Number(r.inputTokens) || 0;
    const o = Number(r.outputTokens) || 0;
    out.inputTokens += i;
    out.outputTokens += o;
    out.totalTokens += i + o;
    out.costUsd += costFor(r.model, i, o);
  }
  // Round the cost to 4 dp — tokens stay exact.
  out.costUsd = Math.round(out.costUsd * 10000) / 10000;
  return out;
}

/** Format USD as "$0.0123" with 4 dp; switches to 2 dp at >= $1. */
export function formatUsd(value) {
  const v = Number(value) || 0;
  if (v >= 1) return `$${v.toFixed(2)}`;
  return `$${v.toFixed(4)}`;
}
